import type { Logger } from '@feature-hub/logger';
import type { VueFormatterServiceInterfaceV1, LocaleServiceV1 } from './feature-service-types';
import { adapterContent } from './adapterContent';
import { getPerSlideWltpCompliance } from './wltpCompliance';

export interface SsrWltpPrecheckArgs {
  isMarketComplianceEnabled: boolean;
  content: unknown;
  vueFormatterService?: VueFormatterServiceInterfaceV1;
  serviceLocale?: LocaleServiceV1;
  logger?: Pick<Logger, 'warn' | 'error'>;
}

export const runSsrWltpPrecheck = async ({
  isMarketComplianceEnabled,
  content,
  vueFormatterService,
  serviceLocale,
  logger,
}: SsrWltpPrecheckArgs): Promise<boolean[] | undefined> => {
  if (!isMarketComplianceEnabled) return undefined;
  if (!vueFormatterService || !serviceLocale) return undefined;

  try {
    const { slides } = adapterContent(content as ContentAem);

    return await getPerSlideWltpCompliance(slides, vueFormatterService, serviceLocale, logger);
  } catch (err) {
    logger?.warn('WLTP SSR compliance pre-check failed', err);
    return undefined;
  }
};
